import React from "react"
import PropTypes from "prop-types"
import { Row, Col, Flex, Card, Tag, Divider, Typography } from "antd"
import { CheckOutlined, MoreOutlined } from "@ant-design/icons"
import { CreditCardIcon } from "ui/Icon/DSIcon/CreditCard"
import SummaryKeyValue from "ui/Booking/Details/Body/PaymentSummary/SummaryKeyValue"
import useSummaryDetails from "ui/Booking/Details/Body/PaymentSummary/hooks/useSummaryDetails"
import styles from "../../index.module.css"

const { Text } = Typography

const PaymentCard = React.memo(({totalAmount,paymentMethod, paymentSummary, paymentHistory, pricing }) => {
  console.log(totalAmount,'totalAmountttt')
  const paymentDetails = useSummaryDetails(paymentSummary, pricing)
  const { total_price } = paymentSummary || {}

  return (
    <Card className={styles.mainCard} title="Payment">
      <Row gutter={[16]}>
        <Col lg={12}>
          <div className={styles.priceDetails}>
            <Flex align="center" gap={16} justify="space-between">
              <Text className="color-text-secondary-dark" strong>
                Price Details
              </Text>
              <Tag className={`${styles.tagBooked} mr-0`}>
                <CheckOutlined />
                Paid in full
              </Tag>
            </Flex>
            <div className="mt-l">
              <SummaryKeyValue details={paymentDetails} valueAlign="right" />
            </div>
            <Divider className="my-xs" />
            <Flex align="center" justify="space-between">
              <Text strong>Total</Text>
              <Text strong>${total_price}</Text>
            </Flex>
          </div>
        </Col>
        <Col lg={12}>
          <div className={styles.priceDetails}>
            <Flex align="center" justify="space-between" gap={10} className="mb-s">
              <Text className="color-text-secondary-dark" strong>
                Payment Method
              </Text>
            </Flex>
            {(paymentHistory || []).map((payment, index) => {
              const isPaymentCash = payment.method?.toLowerCase().includes("cash")
              return (
                <Card key={index} className={index > 0 ? "mt-s" : ""}>
                  <Flex align="center" gap={8}>
                    {!isPaymentCash && <CreditCardIcon />}
                    <div className="flex-1">
                      <Flex align="center" gap={8} justify="space-between">
                        <Text strong>{isPaymentCash ? "Cash" : payment.method}</Text>
                        <Text strong>${payment.amount}</Text>
                      </Flex>
                      <Flex align="center" justify="space-between">
                        <Text className="color-text-secondary-dark">{!isPaymentCash && payment.last4 && `****${payment.last4}`}</Text>
                        <Text className="color-text-secondary-dark">Paid</Text>
                      </Flex>
                    </div>
                  </Flex>
                </Card>
              )
            })}
          </div>
        </Col>
      </Row>
    </Card>
  )
})

PaymentCard.propTypes = {
  paymentSummary: PropTypes.shape({
    total_price: PropTypes.number
  }),
  paymentHistory: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number,
      last4: PropTypes.string
    })
  ),
  pricing: PropTypes.object
}

PaymentCard.displayName = "PaymentCard"

export default PaymentCard
